import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ImmomioIconName, ITicketMessage, ITicketMessageGroup } from '../../models';

@Directive()
export abstract class MessageGroupBaseComponent {
  @Input() messageGroup: ITicketMessageGroup;
  @Input() previousDayKey: string | undefined;
  @Output() retryMessageEvent = new EventEmitter<ITicketMessage>();
  public immomioIconName = ImmomioIconName;

  get showDaySeparator(): boolean {
    return this.messageGroup?.dayKey !== this.previousDayKey;
  }
}
